'use client'

import { BlogPostCategory } from '@types'

import useDateTime from '@hooks/client/useDateTime'
import { minutesToRead } from '@lib/helpers/client'

import styles from './post-info.module.scss'

type PostInfoProps = {
  body?: string
  date?: number
  categories?: BlogPostCategory[]
}

export default function PostInfo({ body, date, categories }: PostInfoProps): JSX.Element {
  const minutes = minutesToRead(body?.split(' ').length)

  const dayjs = useDateTime()

  return (
    <ul className={styles.info}>
      <li>{minutes} minutes to read</li>
      <li className={styles.dot}>&#8226;</li>
      <li>Posted {dayjs(date).fromNow()}</li>
      <li className={styles.dot}>&#8226;</li>
      <li className={styles.categories}>
        {categories?.map((c, i) => (
          <span key={i} className={styles.category}>
            {c.name}
          </span>
        ))}
      </li>
    </ul>
  )
}
